import { motion } from 'framer-motion';

const ImageCaption = ({ title, caption, animated = false }) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  if (animated) {
    return (
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="text-white"
      >
        {title && (
          <motion.h3
            variants={itemVariants}
            className="text-2xl md:text-3xl font-display font-bold mb-2 drop-shadow-lg"
          >
            {title}
          </motion.h3>
        )}
        {caption && (
          <motion.p
            variants={itemVariants}
            className="text-lg text-white/90 drop-shadow-md max-w-2xl"
          >
            {caption}
          </motion.p>
        )}
      </motion.div>
    );
  }

  return (
    <div className="text-white mt-4 text-center">
      {title && (
        <h3 className="text-xl md:text-2xl font-display font-bold mb-2">
          {title}
        </h3>
      )}
      {caption && (
        <p className="text-base text-white/90 max-w-2xl mx-auto">
          {caption}
        </p>
      )}
    </div>
  );
};

export default ImageCaption;